
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"id":"Wrench","d":"M16.64 8.43L16 6.64a.92.92 0 01.54-1.17l3.59-1.3a.46.46 0 00.15-.77 5.52 5.52 0 00-9 2.77 5.42 5.42 0 00.35 3.54l-8.64 7.7a2.65 2.65 0 00-.29 3.76 2.61 2.61 0 003.86 0l7.81-8.72a5.76 5.76 0 005.29-.45A4.93 4.93 0 0022 8.2a.47.47 0 00-.61-.5L17.82 9a.92.92 0 01-1.18-.57z"}})])
          )
        }
      }
    